module.exports = __webpack_public_path__ + "static/media/user_ex1.772f481e.svg";